import { MESFMain } from "@dexteel/mesf-core";
import "react-datepicker/dist/react-datepicker.css";
import { render } from "react-dom";
import "./app.css";
import "./setup/ag-grid-license";

import { AuthenticationConfig } from "@setup/auth-config";
import { customConfigurations } from "@setup/configurations";
import { CustomNavbar } from "@setup/navbar";
import { CustomRoutes } from "@setup/routes";
import { logbookSettings } from "@setup/logbook-settings";

render(
	<MESFMain
		routes={CustomRoutes}
		navbar={CustomNavbar}
		navbarTitle="RBD-CMMS"
		plantAssetId={0}
		showAreaSelector={true}
		showTrendingsV2Icon={false}
		configurations={customConfigurations}
		authentication={AuthenticationConfig}
		logbookSettings={logbookSettings}
	/>,
	document.getElementById("root"),
);
